(function () {
    // Sortierung und Facettenfilter rechnet Shopify serverseitig - da haelt
    // sich das Skript raus. Tag-Filter im Pfad bildet es dagegen selbst nach
    // (siehe activeTag), damit auch dort ausverkaufte Artikel hinten stehen.
    function hasActiveFilterOrSort() {
        var params = new URLSearchParams(window.location.search);
        var keys = Array.from(params.keys());
        for (var i = 0; i < keys.length; i++) {
            if (keys[i] === 'sort_by' || keys[i].indexOf('filter.') === 0) {
                return true;
            }
        }
        return false;
    }

    // Aus /collections/<handle>/<tag> den aktiven Tag lesen.
    function activeTag() {
        var teile = window.location.pathname.split('/').filter(function (s) { return s !== ''; });
        var i = teile.indexOf('collections');
        if (i === -1 || teile.length <= i + 2) return null;
        try { return handleize(decodeURIComponent(teile[i + 2])); }
        catch (e) { return handleize(teile[i + 2]); }
    }

    // Shopify vergleicht Tags in ihrer Handle-Form: aus "§42a konform"
    // wird "42a-konform". Ohne das faende der Filter solche Produkte nicht.
    function handleize(wert) {
        return String(wert).toLowerCase()
            .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function hasTag(product, tag) {
        var tags = product.tags || [];
        for (var i = 0; i < tags.length; i++) {
            if (handleize(tags[i]) === tag) return true;
        }
        return false;
    }

    function isAvailable(product) {
        return !!(product.variants && product.variants.some(function (v) { return v.available; }));
    }

    function sortAvailableFirst(products) {
        var available = [];
        var soldOut = [];
        products.forEach(function (p) {
            (isAvailable(p) ? available : soldOut).push(p);
        });
        return available.concat(soldOut);
    }

    function fetchFullCollection(handle) {
        var perFetch = 250;
        function fetchPage(page, acc) {
            return fetch('/collections/' + handle + '/products.json?limit=' + perFetch + '&page=' + page)
                .then(function (response) { return response.ok ? response.json() : { products: [] }; })
                .then(function (data) {
                    var products = data.products || [];
                    acc = acc.concat(products);
                    if (products.length === perFetch) {
                        return fetchPage(page + 1, acc);
                    }
                    return acc;
                });
        }
        return fetchPage(1, []);
    }

    function fetchCardListItem(handle) {
        return fetch('/products/' + handle + '?view=ajax_section_recently_viewed')
            .then(function (response) { return response.ok ? response.text() : null; })
            .then(function (html) {
                if (!html) return null;
                var tmp = document.createElement('div');
                tmp.innerHTML = html.trim();
                var source = tmp.querySelector('.product');
                if (!source) return null;
                var li = document.createElement('li');
                li.className = source.className || 'product';
                li.innerHTML = source.innerHTML;
                return li;
            })
            .catch(function () { return null; });
    }


    // Die Bewertungssterne stehen nicht im Server-HTML - die Bewertungs-App
    // traegt sie nachtraeglich in leere Platzhalter ein. Da dieses Skript das
    // Raster komplett neu aufbaut, sind die Platzhalter danach wieder leer und
    // die Sterne verschwinden. Also die App bitten, erneut darueber zu laufen.
    // Findet sie sich nicht, bleibt einfach alles wie bisher.
    function bewertungenNeuZeichnen() {
        var versuche = 0;
        (function anstossen() {
            versuche++;
            try {
                var tr = window.TrustooReviews;
                if (tr && tr.reviews && typeof tr.reviews.checkCollEmbed === 'function') {
                    tr.reviews.checkCollEmbed();
                    return;
                }
            } catch (e) { /* App nicht verfuegbar - dann eben ohne */ }
            if (versuche < 12) setTimeout(anstossen, 400);
        })();
    }

    function init(grid) {
        if (hasActiveFilterOrSort()) return;

        var handle = grid.getAttribute('data-collection-handle');
        var perPage = parseInt(grid.getAttribute('data-products-per-page'), 10);
        var currentPage = parseInt(grid.getAttribute('data-current-page'), 10) || 1;
        if (!handle || !perPage) return;

        var tag = activeTag();

        fetchFullCollection(handle).then(function (allProducts) {
            var gefiltert = tag
                ? allProducts.filter(function (p) { return hasTag(p, tag); })
                : allProducts;
            // Greift der Tag ins Leere, lieber nichts anfassen als eine
            // leere Seite bauen - dann bleibt die Serverausgabe stehen.
            if (tag && !gefiltert.length) return;
            var sorted = sortAvailableFirst(gefiltert);
            var start = (currentPage - 1) * perPage;
            var pageSlice = sorted.slice(start, start + perPage);
            if (!pageSlice.length) return;

            return Promise.all(pageSlice.map(function (product) {
                return fetchCardListItem(product.handle);
            })).then(function (items) {
                var validItems = items.filter(Boolean);
                if (!validItems.length) return;
                grid.innerHTML = '';
                validItems.forEach(function (li) { grid.appendChild(li); });
                bewertungenNeuZeichnen();
            });
        }).catch(function (err) {
            console.error('collection-sold-out-last:', err);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('[data-sold-out-last]').forEach(init);
    });
})();
